import { FC, useRef, useEffect, useCallback, HTMLAttributes } from 'react'
import { defaultMemoize } from 'reselect'
import { Omit } from 'interfaces'
import { SubtreeMutation } from 'components/features/pfm/SubtreeMutation/SubtreeMutation'

type SizeHandlerProps =
  & Omit<HTMLAttributes<HTMLDivElement>, 'onChange'>
  & {
    boundClassName?: string
    onChange: (rect: ClientRect) => void
  }

export const SizeHandler: FC<SizeHandlerProps> = (props) => {
  const { children, boundClassName, onChange, ...restProps } = props

  const ref = useRef<HTMLDivElement>(null)

  const handleChange = useCallback(defaultMemoize((_clientWidth: number, _clientHeight: number, _clientLeft: number, _clientTop: number) => {
    const { current } = ref
    if (!current) {
      return
    }

    onChange(current.getBoundingClientRect())
  }), [onChange])

  const handleUpdate = useCallback(() => {
    const { current } = ref
    if (!current) {
      return
    }

    const { clientWidth, clientHeight, clientLeft, clientTop } = current
    handleChange(clientWidth, clientHeight, clientLeft, clientTop)
  }, [handleChange])

  useEffect(() => {
    window.addEventListener('resize', handleUpdate)

    return () => {
      window.removeEventListener('resize', handleUpdate)
    }
  }, [handleUpdate])
  useEffect(() => {
    handleUpdate()

  }, [handleUpdate])

  return (
    <SubtreeMutation onChange={ handleUpdate } className={ boundClassName }>
      <div ref={ ref } { ...restProps }>
        { children }
      </div>
    </SubtreeMutation>
  )
}
